// import React, { useState } from "react";
// import {
//   Button,
//   IconButton,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   TextField,
//   Chip,
//   Avatar,
//   Tooltip,
//   LinearProgress,
//   Divider,
//   Badge,
//   CircularProgress,
//   Switch,
//   FormControlLabel,
// } from "@mui/material";
// import {
//   Visibility,
//   Edit,
//   Delete,
//   Add,
//   Schedule,
//   CalendarToday,
//   AccessTime,
//   Event,
//   People,
//   Settings,
//   Notifications,
//   Dashboard,
//   ChevronRight,
//   CheckCircle,
//   Warning,
//   Info,
//   ArrowForward,
//   Refresh,
//   Download,
//   Upload,
//   FilterList,
//   Search,
//   MoreVert,
// } from "@mui/icons-material";
// import {
//   Box,
//   TableContainer,
//   Paper,
//   Table,
//   Typography,
//   TableBody,
//   TableHead,
//   TableRow,
//   TableCell,
//   Card,
//   CardContent,
//   Grid,
//   Container,
//   Stack,
//   useTheme,
//   useMediaQuery,
// } from "@mui/material";
// import "./Attendance.css";

// function CompanyAttendancePremium() {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));
//   const isTablet = useMediaQuery(theme.breakpoints.down('lg'));

//   // Enhanced Color Indicator System
//   const ColorIndicator = ({ type, size = "medium", tooltip = "" }) => {
//     const sizeMap = {
//       small: "12px",
//       medium: "20px",
//       large: "28px"
//     };
    
//     return (
//       <Tooltip title={tooltip} className="premium-tooltip">
//         <span 
//           className={`color-indicator ${type}`}
//           style={{ 
//             width: sizeMap[size], 
//             height: sizeMap[size],
//             boxShadow: `0 2px 8px ${getColorShadow(type)}`
//           }}
//         />
//       </Tooltip>
//     );
//   };

//   const getColorShadow = (type) => {
//     const shadows = {
//       working: "rgba(72, 187, 120, 0.3)",
//       off: "rgba(239, 68, 68, 0.3)",
//       half: "rgba(245, 158, 11, 0.3)",
//       holiday: "rgba(139, 92, 246, 0.3)"
//     };
//     return shadows[type] || "rgba(0, 0, 0, 0.1)";
//   };

//   // State Management
//   const [addresses, setAddresses] = useState([
//     { id: 1, shiftName: "Morning Shift", inTime: "09:00 AM", outTime: "05:00 PM", status: "active", color: "working" },
//     { id: 2, shiftName: "Evening Shift", inTime: "02:00 PM", outTime: "10:00 PM", status: "active", color: "working" },
//     { id: 3, shiftName: "Night Shift", inTime: "10:00 PM", outTime: "06:00 AM", status: "inactive", color: "off" },
//   ]);
  
//   const [holidayData, setHolidayData] = useState([
//     { id: 1, festivalName: "New Year", startDate: "2024-01-01", endDate: "2024-01-01", type: "national" },
//     { id: 2, festivalName: "Diwali", startDate: "2024-11-12", endDate: "2024-11-14", type: "festival" },
//     { id: 3, festivalName: "Christmas", startDate: "2024-12-25", endDate: "2024-12-25", type: "religious" },
//   ]);

//   const [workWeekData, setWorkWeekData] = useState([
//     { week: 1, days: ["working", "working", "working", "working", "working", "working", "off"] },
//     { week: 2, days: ["working", "working", "working", "working", "working", "working", "off"] },
//     { week: 3, days: ["working", "working", "working", "working", "working", "half", "off"] },
//     { week: 4, days: ["working", "working", "working", "working", "working", "working", "off"] },
//     { week: 5, days: ["working", "working", "working", "working", "working", "holiday", "off"] },
//   ]);

//   const [viewOpen, setViewOpen] = useState(false);
//   const [editOpen, setEditOpen] = useState(false);
//   const [selectedRecord, setSelectedRecord] = useState(null);
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [activeTab, setActiveTab] = useState("overview");
//   const [loading, setLoading] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [autoSave, setAutoSave] = useState(true);

//   const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

//   // Enhanced Handlers
//   const handleView = (record, type = "shift") => {
//     setSelectedRecord({ ...record, type });
//     setViewOpen(true);
//   };

//   const handleEdit = (record, type = "shift") => {
//     setSelectedRecord({ ...record, type });
//     setIsEditMode(true);
//     setEditOpen(true);
//   };

//   const handleAddNew = () => {
//     setSelectedRecord({ 
//       type: "shift", 
//       status: "active",
//       color: "working"
//     });
//     setIsEditMode(false);
//     setEditOpen(true);
//   };

//   const handleAddHoliday = () => {
//     setSelectedRecord({ 
//       type: "holiday", 
//       startDate: new Date().toISOString().split('T')[0],
//       endDate: new Date().toISOString().split('T')[0]
//     });
//     setIsEditMode(false);
//     setEditOpen(true);
//   };

//   const handleSaveEdit = () => {
//     setLoading(true);
//     setTimeout(() => {
//       if (isEditMode) {
//         if (selectedRecord.type === "shift") {
//           setAddresses(addresses.map(item => 
//             item.id === selectedRecord.id ? selectedRecord : item
//           ));
//         } else {
//           setHolidayData(holidayData.map(item => 
//             item.id === selectedRecord.id ? selectedRecord : item
//           ));
//         }
//       } else {
//         const newId = Math.max(...[...addresses, ...holidayData].map(d => d.id)) + 1;
//         const newRecord = { ...selectedRecord, id: newId };
        
//         if (selectedRecord.type === "shift") {
//           setAddresses([...addresses, newRecord]);
//         } else {
//           setHolidayData([...holidayData, newRecord]);
//         }
//       }
//       setLoading(false);
//       setEditOpen(false);
//     }, 800);
//   };

//   const handleDelete = (id, type = "shift") => {
//     if (window.confirm("Are you sure you want to delete this record?")) {
//       if (type === "shift") {
//         setAddresses(addresses.filter(item => item.id !== id));
//       } else {
//         setHolidayData(holidayData.filter(item => item.id !== id));
//       }
//     }
//   };

//   // Filtered Data
//   const filteredShifts = addresses.filter(shift =>
//     shift.shiftName.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     shift.inTime.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     shift.outTime.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   const filteredHolidays = holidayData.filter(holiday =>
//     holiday.festivalName.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   // Stats Calculation
//   const totalShifts = addresses.length;
//   const activeShifts = addresses.filter(s => s.status === "active").length;
//   const totalHolidays = holidayData.length;
//   const upcomingHolidays = holidayData.filter(h => new Date(h.startDate) > new Date()).length;

//   return (
//     <div className="premium-attendance">
//       {/* Premium Header */}
//       {/* <div className="premium-header">
//         <Container maxWidth="xl">
//           <div className="header-content">
//             <Typography variant="h1" className="header-title">
//               Attendance Management System
//             </Typography>
//             <Typography variant="h6" className="header-subtitle">
//               Configure and manage company attendance policies, shifts, and holidays with precision control
//             </Typography>
            
//             <div className="header-stats">
//               <div className="stat-card floating-animation">
//                 <span className="stat-number">{totalShifts}</span>
//                 <span className="stat-label">Total Shifts</span>
//               </div>
//               <div className="stat-card floating-animation" style={{animationDelay: '0.2s'}}>
//                 <span className="stat-number">{activeShifts}</span>
//                 <span className="stat-label">Active Shifts</span>
//               </div>
//               <div className="stat-card floating-animation" style={{animationDelay: '0.4s'}}>
//                 <span className="stat-number">{totalHolidays}</span>
//                 <span className="stat-label">Holidays</span>
//               </div>
//               <div className="stat-card floating-animation" style={{animationDelay: '0.6s'}}>
//                 <span className="stat-number">{upcomingHolidays}</span>
//                 <span className="stat-label">Upcoming</span>
//               </div>
//             </div>
//           </div>
//         </Container>
//       </div> */}

//       <Container maxWidth="xl" sx={{ mt: -4, position: 'relative', zIndex: 10 }}>
//         {/* Controls Bar */}
//         {/* <Card className="premium-card" sx={{ mb: 3 }}>
//           <CardContent>
//             <Grid container spacing={2} alignItems="center">
//               <Grid item xs={12} md={4}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                   <div className="icon-wrapper">
//                     <Dashboard />
//                   </div>
//                   <Box>
//                     <Typography variant="h6" sx={{ fontWeight: 700 }}>
//                       Attendance Dashboard
//                     </Typography>
//                     <Typography variant="body2" color="text.secondary">
//                       Real-time configuration panel
//                     </Typography>
//                   </Box>
//                 </Box>
//               </Grid>
              
//               <Grid item xs={12} md={8}>
//                 <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
//                   <TextField
//                     placeholder="Search shifts or holidays..."
//                     variant="outlined"
//                     size="small"
//                     className="premium-input"
//                     value={searchTerm}
//                     onChange={(e) => setSearchTerm(e.target.value)}
//                     InputProps={{
//                       startAdornment: <Search sx={{ mr: 1, color: 'text.secondary' }} />
//                     }}
//                     sx={{ minWidth: 250 }}
//                   />
                  
//                   <Button
//                     variant="contained"
//                     startIcon={<FilterList />}
//                     className="premium-btn premium-btn-secondary"
//                   >
//                     Filters
//                   </Button>
                  
//                   <Button
//                     variant="contained"
//                     startIcon={<Download />}
//                     className="premium-btn premium-btn-secondary"
//                   >
//                     Export
//                   </Button>
                  
//                   <FormControlLabel
//                     control={
//                       <Switch
//                         checked={autoSave}
//                         onChange={(e) => setAutoSave(e.target.checked)}
//                         color="primary"
//                       />
//                     }
//                     label="Auto Save"
//                   />
//                 </Box>
//               </Grid>
//             </Grid>
//           </CardContent>
//         </Card> */}

//         {/* Main Content Grid */}
//         <div className="grid-container">
//           {/* Attendance Cycle Card */}
//           <Card className="premium-card">
//             <CardContent>
//               <Typography variant="h6" className="card-title">
//                 <Schedule sx={{ color: '#667eea' }} />
//                 Attendance Cycle Configuration
//                 <Chip label="Active" color="success" size="small" className="info-badge active" />
//               </Typography>
              
//               <Grid container spacing={3} alignItems="center">
//                 <Grid item xs={12} md={6}>
//                   <Box className="glass-effect" sx={{ p: 3, borderRadius: 2 }}>
//                     <Typography variant="subtitle2" color="text.secondary" gutterBottom>
//                       CYCLE DURATION
//                     </Typography>
//                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                       <TextField
//                         type="number"
//                         defaultValue="1"
//                         className="premium-input"
//                         label="Start Day"
//                         size="small"
//                         InputProps={{ sx: { textAlign: 'center' } }}
//                       />
//                       <ChevronRight color="action" />
//                       <TextField
//                         type="number"
//                         defaultValue="31"
//                         className="premium-input"
//                         label="End Day"
//                         size="small"
//                         InputProps={{ sx: { textAlign: 'center' } }}
//                       />
//                     </Box>
//                     <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
//                       Monthly cycle running from day 1 to day 31
//                     </Typography>
//                   </Box>
//                 </Grid>
                
//                 <Grid item xs={12} md={6}>
//                   <Box className="glass-effect" sx={{ p: 3, borderRadius: 2 }}>
//                     <Typography variant="subtitle2" color="text.secondary" gutterBottom>
//                       CYCLE PROGRESS
//                     </Typography>
//                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                       <Box sx={{ flexGrow: 1 }}>
//                         <LinearProgress 
//                           variant="determinate" 
//                           value={65} 
//                           sx={{ 
//                             height: 8, 
//                             borderRadius: 4,
//                             backgroundColor: 'rgba(102, 126, 234, 0.1)',
//                             '& .MuiLinearProgress-bar': {
//                               background: 'var(--primary-gradient)',
//                             }
//                           }}
//                         />
//                       </Box>
//                       <Typography variant="h6" color="primary">
//                         65%
//                       </Typography>
//                     </Box>
//                     <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
//                       Current day: 20 of 31
//                     </Typography>
//                   </Box>
//                 </Grid>
//               </Grid>
//             </CardContent>
//           </Card>

//           {/* Work Week Card */}
//           <Card className="premium-card">
//             <CardContent>
//               <Typography variant="h6" className="card-title">
//                 <CalendarToday sx={{ color: '#764ba2' }} />
//                 Work Week Schedule
//                 <Chip label="6 Days" color="primary" size="small" className="badge-primary" />
//               </Typography>
              
//               <Box sx={{ mb: 3 }}>
//                 <Grid container spacing={2} alignItems="center">
//                   <Grid item xs={12} md={8}>
//                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                       <Typography variant="body2" color="text.secondary">
//                         Working days per week:
//                       </Typography>
//                       <TextField
//                         type="number"
//                         defaultValue="6"
//                         className="premium-input"
//                         size="small"
//                         sx={{ width: 80 }}
//                       />
//                       <select className="premium-select" style={{ minWidth: 150 }}>
//                         <option>Monthly Cycle</option>
//                         <option>Weekly Cycle</option>
//                         <option>Custom Cycle</option>
//                       </select>
//                     </Box>
//                   </Grid>
//                   <Grid item xs={12} md={4} sx={{ textAlign: { md: 'right' } }}>
//                     <Typography variant="body2" sx={{ color: 'success.main', fontWeight: 600 }}>
//                       <CheckCircle sx={{ fontSize: 16, verticalAlign: 'middle', mr: 0.5 }} />
//                       Effective: 05 Feb, 2025
//                     </Typography>
//                   </Grid>
//                 </Grid>
//               </Box>

//               {/* Work Week Table */}
//               <Box className="premium-scrollbar">
//                 <TableContainer className="premium-table-container">
//                   <Table className="premium-table">
//                     <TableHead>
//                       <TableRow>
//                         <TableCell className="premium-table-header">Week</TableCell>
//                         {days.map((day) => (
//                           <TableCell key={day} className="premium-table-header" align="center">
//                             {day}
//                           </TableCell>
//                         ))}
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       {workWeekData.map((row) => (
//                         <TableRow key={row.week} className="premium-table-row">
//                           <TableCell className="premium-table-cell" sx={{ fontWeight: 700 }}>
//                             Week {row.week}
//                           </TableCell>
//                           {row.days.map((type, i) => (
//                             <TableCell key={i} className="premium-table-cell" align="center">
//                               <ColorIndicator type={type} tooltip={type.charAt(0).toUpperCase() + type.slice(1)} />
//                             </TableCell>
//                           ))}
//                         </TableRow>
//                       ))}
//                     </TableBody>
//                   </Table>
//                 </TableContainer>
//               </Box>

//               {/* Legend */}
//               <div className="legend-container">
//                 <div className="legend-item">
//                   <ColorIndicator type="working" />
//                   <span>Working Day</span>
//                 </div>
//                 <div className="legend-item">
//                   <ColorIndicator type="off" />
//                   <span>Weekly Off</span>
//                 </div>
//                 <div className="legend-item">
//                   <ColorIndicator type="half" />
//                   <span>Half Day</span>
//                 </div>
//                 <div className="legend-item">
//                   <ColorIndicator type="holiday" />
//                   <span>Public Holiday</span>
//                 </div>
//               </div>
//             </CardContent>
//           </Card>

//           {/* Shift Management Card */}
//           <Card className="premium-card">
//             <CardContent>
//               <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                   <div className="icon-wrapper">
//                     <AccessTime />
//                   </div>
//                   <Box>
//                     <Typography variant="h6" className="card-title" sx={{ mb: 0 }}>
//                       Shift Management
//                     </Typography>
//                     <Typography variant="caption" color="text.secondary">
//                       {activeShifts} active shifts configured
//                     </Typography>
//                   </Box>
//                 </Box>
//                 <Button
//                   variant="contained"
//                   startIcon={<Add />}
//                   onClick={handleAddNew}
//                   className="premium-btn premium-btn-primary"
//                 >
//                   New Shift
//                 </Button>
//               </Box>

//               <div className="premium-scrollbar">
//                 <TableContainer className="premium-table-container">
//                   <Table className="premium-table">
//                     <TableHead>
//                       <TableRow>
//                         <TableCell className="premium-table-header">Shift</TableCell>
//                         <TableCell className="premium-table-header">Timing</TableCell>
//                         <TableCell className="premium-table-header">Status</TableCell>
//                         <TableCell className="premium-table-header">Actions</TableCell>
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       {filteredShifts.map((shift) => (
//                         <TableRow key={shift.id} className="premium-table-row">
//                           <TableCell className="premium-table-cell">
//                             <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                               <ColorIndicator type={shift.color} />
//                               <Box>
//                                 <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
//                                   {shift.shiftName}
//                                 </Typography>
//                                 <Typography variant="caption" color="text.secondary">
//                                   ID: SHF-{shift.id.toString().padStart(3, '0')}
//                                 </Typography>
//                               </Box>
//                             </Box>
//                           </TableCell>
//                           <TableCell className="premium-table-cell">
//                             <Box>
//                               <Typography variant="body2">
//                                 <AccessTime sx={{ fontSize: 14, mr: 0.5, verticalAlign: 'middle' }} />
//                                 {shift.inTime} - {shift.outTime}
//                               </Typography>
//                               <Typography variant="caption" color="text.secondary">
//                                 8 hours duration
//                               </Typography>
//                             </Box>
//                           </TableCell>
//                           <TableCell className="premium-table-cell">
//                             <Chip 
//                               label={shift.status === 'active' ? 'Active' : 'Inactive'} 
//                               size="small"
//                               color={shift.status === 'active' ? 'success' : 'error'}
//                               className={`status-${shift.status}`}
//                             />
//                           </TableCell>
//                           <TableCell className="premium-table-cell">
//                             <Stack direction="row" spacing={1}>
//                               <Tooltip title="View Details">
//                                 <IconButton
//                                   onClick={() => handleView(shift, "shift")}
//                                   className="action-btn action-btn-view"
//                                   size="small"
//                                 >
//                                   <Visibility fontSize="small" />
//                                 </IconButton>
//                               </Tooltip>
//                               <Tooltip title="Edit Shift">
//                                 <IconButton
//                                   onClick={() => handleEdit(shift, "shift")}
//                                   className="action-btn action-btn-edit"
//                                   size="small"
//                                 >
//                                   <Edit fontSize="small" />
//                                 </IconButton>
//                               </Tooltip>
//                               <Tooltip title="Delete Shift">
//                                 <IconButton
//                                   onClick={() => handleDelete(shift.id, "shift")}
//                                   className="action-btn action-btn-delete"
//                                   size="small"
//                                 >
//                                   <Delete fontSize="small" />
//                                 </IconButton>
//                               </Tooltip>
//                             </Stack>
//                           </TableCell>
//                         </TableRow>
//                       ))}
//                     </TableBody>
//                   </Table>
//                 </TableContainer>
//               </div>
//             </CardContent>
//           </Card>

//           {/* Holiday Management Card */}
//           <Card className="premium-card">
//             <CardContent>
//               <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                   <div className="icon-wrapper">
//                     <Event />
//                   </div>
//                   <Box>
//                     <Typography variant="h6" className="card-title" sx={{ mb: 0 }}>
//                       Holiday Calendar
//                     </Typography>
//                     <Typography variant="caption" color="text.secondary">
//                       {upcomingHolidays} upcoming holidays
//                     </Typography>
//                   </Box>
//                 </Box>
//                 <Button
//                   variant="contained"
//                   startIcon={<Add />}
//                   onClick={handleAddHoliday}
//                   className="premium-btn premium-btn-primary"
//                 >
//                   Add Holiday
//                 </Button>
//               </Box>

//               <div className="premium-scrollbar">
//                 <TableContainer className="premium-table-container">
//                   <Table className="premium-table">
//                     <TableHead>
//                       <TableRow>
//                         <TableCell className="premium-table-header">Festival</TableCell>
//                         <TableCell className="premium-table-header">Date Range</TableCell>
//                         <TableCell className="premium-table-header">Type</TableCell>
//                         <TableCell className="premium-table-header">Actions</TableCell>
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       {filteredHolidays.map((holiday) => {
//                         const isUpcoming = new Date(holiday.startDate) > new Date();
//                         return (
//                           <TableRow key={holiday.id} className="premium-table-row">
//                             <TableCell className="premium-table-cell">
//                               <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                                 <Avatar
//                                   sx={{
//                                     width: 32,
//                                     height: 32,
//                                     bgcolor: isUpcoming ? 'warning.light' : 'primary.light',
//                                     fontSize: 14
//                                   }}
//                                 >
//                                   {holiday.festivalName.charAt(0)}
//                                 </Avatar>
//                                 <Box>
//                                   <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
//                                     {holiday.festivalName}
//                                   </Typography>
//                                   <Typography variant="caption" color="text.secondary">
//                                     {isUpcoming ? 'Upcoming' : 'Passed'}
//                                   </Typography>
//                                 </Box>
//                               </Box>
//                             </TableCell>
//                             <TableCell className="premium-table-cell">
//                               <Box>
//                                 <Typography variant="body2">
//                                   {new Date(holiday.startDate).toLocaleDateString()} - 
//                                   {new Date(holiday.endDate).toLocaleDateString()}
//                                 </Typography>
//                                 <Typography variant="caption" color="text.secondary">
//                                   {Math.ceil((new Date(holiday.endDate) - new Date(holiday.startDate)) / (1000 * 60 * 60 * 24) + 1)} days
//                                 </Typography>
//                               </Box>
//                             </TableCell>
//                             <TableCell className="premium-table-cell">
//                               <Chip 
//                                 label={holiday.type.charAt(0).toUpperCase() + holiday.type.slice(1)} 
//                                 size="small"
//                                 variant="outlined"
//                               />
//                             </TableCell>
//                             <TableCell className="premium-table-cell">
//                               <Stack direction="row" spacing={1}>
//                                 <Tooltip title="View Details">
//                                   <IconButton
//                                     onClick={() => handleView(holiday, "holiday")}
//                                     className="action-btn action-btn-view"
//                                     size="small"
//                                   >
//                                     <Visibility fontSize="small" />
//                                   </IconButton>
//                                 </Tooltip>
//                                 <Tooltip title="Edit Holiday">
//                                   <IconButton
//                                     onClick={() => handleEdit(holiday, "holiday")}
//                                     className="action-btn action-btn-edit"
//                                     size="small"
//                                   >
//                                     <Edit fontSize="small" />
//                                   </IconButton>
//                                 </Tooltip>
//                                 <Tooltip title="Delete Holiday">
//                                   <IconButton
//                                     onClick={() => handleDelete(holiday.id, "holiday")}
//                                     className="action-btn action-btn-delete"
//                                     size="small"
//                                   >
//                                     <Delete fontSize="small" />
//                                   </IconButton>
//                                 </Tooltip>
//                               </Stack>
//                             </TableCell>
//                           </TableRow>
//                         );
//                       })}
//                     </TableBody>
//                   </Table>
//                 </TableContainer>
//               </div>
//             </CardContent>
//           </Card>
//         </div>

//         {/* Action Buttons */}
//         <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center', gap: 2, flexWrap: 'wrap' }}>
//           <Button
//             variant="outlined"
//             startIcon={<Refresh />}
//             className="premium-btn premium-btn-secondary"
//             sx={{ px: 4 }}
//           >
//             Reset Changes
//           </Button>
//           <Button
//             variant="contained"
//             endIcon={<ArrowForward />}
//             className="premium-btn premium-btn-primary"
//             sx={{ px: 5 }}
//           >
//             Save & Continue to Rules
//           </Button>
//         </Box>
//       </Container>

//       {/* View Dialog */}
//       <Dialog 
//         open={viewOpen} 
//         onClose={() => setViewOpen(false)}
//         className="premium-dialog"
//         maxWidth="sm"
//         fullWidth
//       >
//         <div className="dialog-header">
//           <DialogTitle className="dialog-title">
//             {selectedRecord?.type === 'holiday' ? '🎉 Holiday Details' : '⏰ Shift Details'}
//           </DialogTitle>
//         </div>
//         <DialogContent className="dialog-content">
//           {selectedRecord?.type === 'holiday' ? (
//             <Box>
//               <Avatar
//                 sx={{
//                   width: 80,
//                   height: 80,
//                   mx: 'auto',
//                   mb: 3,
//                   bgcolor: 'primary.main',
//                   fontSize: 24
//                 }}
//               >
//                 {selectedRecord?.festivalName?.charAt(0)}
//               </Avatar>
              
//               <Grid container spacing={3}>
//                 <Grid item xs={12}>
//                   <Typography variant="h5" align="center" gutterBottom sx={{ fontWeight: 700 }}>
//                     {selectedRecord?.festivalName}
//                   </Typography>
//                   <Typography variant="body1" align="center" color="text.secondary" gutterBottom>
//                     {selectedRecord?.type?.charAt(0).toUpperCase() + selectedRecord?.type?.slice(1)} Holiday
//                   </Typography>
//                 </Grid>
                
//                 <Grid item xs={6}>
//                   <Box className="glass-effect" sx={{ p: 2, borderRadius: 2 }}>
//                     <Typography variant="caption" color="text.secondary" display="block">
//                       Start Date
//                     </Typography>
//                     <Typography variant="h6" sx={{ fontWeight: 600 }}>
//                       {selectedRecord?.startDate ? new Date(selectedRecord.startDate).toLocaleDateString('en-US', {
//                         weekday: 'long',
//                         year: 'numeric',
//                         month: 'long',
//                         day: 'numeric'
//                       }) : '-'}
//                     </Typography>
//                   </Box>
//                 </Grid>
                
//                 <Grid item xs={6}>
//                   <Box className="glass-effect" sx={{ p: 2, borderRadius: 2 }}>
//                     <Typography variant="caption" color="text.secondary" display="block">
//                       End Date
//                     </Typography>
//                     <Typography variant="h6" sx={{ fontWeight: 600 }}>
//                       {selectedRecord?.endDate ? new Date(selectedRecord.endDate).toLocaleDateString('en-US', {
//                         weekday: 'long',
//                         year: 'numeric',
//                         month: 'long',
//                         day: 'numeric'
//                       }) : '-'}
//                     </Typography>
//                   </Box>
//                 </Grid>
//               </Grid>
//             </Box>
//           ) : (
//             <Box>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, mb: 4 }}>
//                 <ColorIndicator type={selectedRecord?.color || "working"} size="large" />
//                 <Box>
//                   <Typography variant="h4" sx={{ fontWeight: 800 }}>
//                     {selectedRecord?.shiftName}
//                   </Typography>
//                   <Typography variant="body1" color="text.secondary">
//                     Shift ID: SHF-{selectedRecord?.id?.toString().padStart(3, '0')}
//                   </Typography>
//                 </Box>
//               </Box>
              
//               <Grid container spacing={3}>
//                 <Grid item xs={12} sm={6}>
//                   <Box className="glass-effect" sx={{ p: 3, borderRadius: 2 }}>
//                     <Typography variant="subtitle2" color="text.secondary" gutterBottom>
//                       IN TIME
//                     </Typography>
//                     <Typography variant="h3" sx={{ fontWeight: 700, color: 'success.main' }}>
//                       {selectedRecord?.inTime || '-'}
//                     </Typography>
//                   </Box>
//                 </Grid>
                
//                 <Grid item xs={12} sm={6}>
//                   <Box className="glass-effect" sx={{ p: 3, borderRadius: 2 }}>
//                     <Typography variant="subtitle2" color="text.secondary" gutterBottom>
//                       OUT TIME
//                     </Typography>
//                     <Typography variant="h3" sx={{ fontWeight: 700, color: 'error.main' }}>
//                       {selectedRecord?.outTime || '-'}
//                     </Typography>
//                   </Box>
//                 </Grid>
                
//                 <Grid item xs={12}>
//                   <Box className="glass-effect" sx={{ p: 3, borderRadius: 2 }}>
//                     <Typography variant="subtitle2" color="text.secondary" gutterBottom>
//                       DURATION & STATUS
//                     </Typography>
//                     <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                       <Typography variant="h5" sx={{ fontWeight: 600 }}>
//                         8 Hours
//                       </Typography>
//                       <Chip 
//                         label={selectedRecord?.status === 'active' ? 'Active' : 'Inactive'} 
//                         color={selectedRecord?.status === 'active' ? 'success' : 'error'}
//                         sx={{ fontWeight: 600 }}
//                       />
//                     </Box>
//                   </Box>
//                 </Grid>
//               </Grid>
//             </Box>
//           )}
//         </DialogContent>
//         <DialogActions className="dialog-actions">
//           <Button 
//             onClick={() => setViewOpen(false)} 
//             className="premium-btn premium-btn-secondary"
//           >
//             Close
//           </Button>
//           <Button 
//             onClick={() => {
//               setViewOpen(false);
//               handleEdit(selectedRecord, selectedRecord?.type);
//             }}
//             className="premium-btn premium-btn-primary"
//           >
//             Edit
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Edit/Add Dialog */}
//       <Dialog 
//         open={editOpen} 
//         onClose={() => setEditOpen(false)}
//         className="premium-dialog"
//         maxWidth="sm"
//         fullWidth
//       >
//         <div className="dialog-header">
//           <DialogTitle className="dialog-title">
//             {isEditMode ? '✏️ Edit' : '➕ Add New'} {selectedRecord?.type === 'holiday' ? 'Holiday' : 'Shift'}
//           </DialogTitle>
//         </div>
//         <DialogContent className="dialog-content">
//           {loading ? (
//             <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 200 }}>
//               <CircularProgress size={60} />
//             </Box>
//           ) : selectedRecord?.type === 'holiday' ? (
//             <Box sx={{ '& .MuiTextField-root': { mb: 3 } }}>
//               <TextField
//                 fullWidth
//                 label="Festival Name"
//                 value={selectedRecord?.festivalName || ''}
//                 onChange={(e) => setSelectedRecord({...selectedRecord, festivalName: e.target.value})}
//                 className="premium-input"
//                 required
//               />
              
//               <Grid container spacing={2}>
//                 <Grid item xs={6}>
//                   <TextField
//                     fullWidth
//                     label="Start Date"
//                     type="date"
//                     value={selectedRecord?.startDate || ''}
//                     onChange={(e) => setSelectedRecord({...selectedRecord, startDate: e.target.value})}
//                     className="premium-input"
//                     InputLabelProps={{ shrink: true }}
//                     required
//                   />
//                 </Grid>
//                 <Grid item xs={6}>
//                   <TextField
//                     fullWidth
//                     label="End Date"
//                     type="date"
//                     value={selectedRecord?.endDate || ''}
//                     onChange={(e) => setSelectedRecord({...selectedRecord, endDate: e.target.value})}
//                     className="premium-input"
//                     InputLabelProps={{ shrink: true }}
//                     required
//                   />
//                 </Grid>
//               </Grid>
              
//               <TextField
//                 fullWidth
//                 select
//                 label="Holiday Type"
//                 value={selectedRecord?.type || 'national'}
//                 onChange={(e) => setSelectedRecord({...selectedRecord, type: e.target.value})}
//                 className="premium-select"
//                 SelectProps={{
//                   native: true,
//                 }}
//               >
//                 <option value="national">National Holiday</option>
//                 <option value="festival">Festival</option>
//                 <option value="religious">Religious</option>
//                 <option value="optional">Optional</option>
//               </TextField>
//             </Box>
//           ) : (
//             <Box sx={{ '& .MuiTextField-root': { mb: 3 } }}>
//               <TextField
//                 fullWidth
//                 label="Shift Name"
//                 value={selectedRecord?.shiftName || ''}
//                 onChange={(e) => setSelectedRecord({...selectedRecord, shiftName: e.target.value})}
//                 className="premium-input"
//                 required
//               />
              
//               <Grid container spacing={2}>
//                 <Grid item xs={6}>
//                   <TextField
//                     fullWidth
//                     label="In Time"
//                     type="time"
//                     value={selectedRecord?.inTime || ''}
//                     onChange={(e) => setSelectedRecord({...selectedRecord, inTime: e.target.value})}
//                     className="premium-input"
//                     InputLabelProps={{ shrink: true }}
//                     required
//                   />
//                 </Grid>
//                 <Grid item xs={6}>
//                   <TextField
//                     fullWidth
//                     label="Out Time"
//                     type="time"
//                     value={selectedRecord?.outTime || ''}
//                     onChange={(e) => setSelectedRecord({...selectedRecord, outTime: e.target.value})}
//                     className="premium-input"
//                     InputLabelProps={{ shrink: true }}
//                     required
//                   />
//                 </Grid>
//               </Grid>
              
//               <Box sx={{ display: 'flex', gap: 2 }}>
//                 <FormControlLabel
//                   control={
//                     <Switch
//                       checked={selectedRecord?.status === 'active'}
//                       onChange={(e) => setSelectedRecord({
//                         ...selectedRecord, 
//                         status: e.target.checked ? 'active' : 'inactive'
//                       })}
//                       color="primary"
//                     />
//                   }
//                   label={selectedRecord?.status === 'active' ? 'Active' : 'Inactive'}
//                 />
                
//                 <Box sx={{ flexGrow: 1, display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
//                   {['working', 'off', 'half'].map((color) => (
//                     <Tooltip key={color} title={color.charAt(0).toUpperCase() + color.slice(1)}>
//                       <IconButton
//                         onClick={() => setSelectedRecord({...selectedRecord, color})}
//                         sx={{
//                           width: 32,
//                           height: 32,
//                           border: selectedRecord?.color === color ? '2px solid #667eea' : '2px solid transparent',
//                         }}
//                       >
//                         <ColorIndicator type={color} size="small" />
//                       </IconButton>
//                     </Tooltip>
//                   ))}
//                 </Box>
//               </Box>
//             </Box>
//           )}
//         </DialogContent>
//         <DialogActions className="dialog-actions">
//           <Button 
//             onClick={() => setEditOpen(false)} 
//             className="premium-btn premium-btn-secondary"
//             disabled={loading}
//           >
//             Cancel
//           </Button>
//           <Button 
//             onClick={handleSaveEdit} 
//             className="premium-btn premium-btn-primary"
//             disabled={loading}
//           >
//             {loading ? 'Saving...' : isEditMode ? 'Update' : 'Save'}
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </div>
//   );
// }

// export default CompanyAttendancePremium;


import React, { useState } from "react";
import {
  Button,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { Visibility, Edit, Delete } from "@mui/icons-material";
import {
  Box,
  TableContainer,
  Paper,
  Table,
  Typography,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
} from "@mui/material";

function Companyattendance() {
  const getColorBox = (color) => {
    return (
      <Box
        sx={{
          width: 16,
          height: 16,
          backgroundColor: color,
          display: "inline-block",
          borderRadius: "3px",
        }}
      />
    );
  };

  const [addresses, setAddresses] = useState([{}]);
  const [holidayData, setHolidayData] = useState([{}]);
  const [viewOpen, setViewOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);

  const workWeekData = [
    {
      week: 1,
      days: ["green", "green", "green", "green", "green", "green", "red"],
    },
    {
      week: 2,
      days: ["green", "green", "green", "green", "green", "green", "red"],
    },
    {
      week: 3,
      days: ["green", "green", "green", "green", "green", "green", "red"],
    },
    {
      week: 4,
      days: ["green", "green", "green", "green", "green", "green", "red"],
    },
    {
      week: 5,
      days: ["green", "green", "green", "green", "green", "green", "red"],
    },
  ];

  const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

  const handleHolidayView = (index) => {
    setSelectedRecord(holidayData[index]);
    setViewOpen(true);
  };

  const handleHolidayEdit = (index) => {
    setSelectedRecord(holidayData[index]);
    setEditOpen(true);
  };

  const handleHolidayDelete = (index) => {
    const updatedHolidayData = holidayData.filter((_, i) => i !== index);
    setHolidayData(updatedHolidayData);
  };

  const handleView = (index) => {
    setSelectedRecord(addresses[index]);
    setViewOpen(true);
  };

  const handleEdit = (index) => {
    setSelectedRecord(addresses[index]);
    setEditOpen(true);
  };

  const handleDelete = (index) => {
    const updatedAddresses = addresses.filter((_, i) => i !== index);
    setAddresses(updatedAddresses);
  };

  const handleCloseViewDialog = () => {
    setViewOpen(false);
  };

  const handleCloseEditDialog = () => {
    setEditOpen(false);
  };

  const handleSaveEdit = () => {
    const updatedAddresses = addresses.map((address, index) =>
      index === selectedRecord ? selectedRecord : address
    );
    setAddresses(updatedAddresses);
    setEditOpen(false);
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <Box
            sx={{
              maxHeight: { xs: "auto", md: "500px" },
              overflowY: "auto",
              scrollbarWidth: "none",
              "&::-webkit-scrollbar": { display: "none" },
              padding: { xs: 1, sm: 2, md: 3 },
            }}
          >
            {/* Attendance Cycle */}
            <div className="border p-3 p-md-4 rounded-md mb-4 shadow-lg">
              <h4 className="font-bold mb-2 text-primary h5">
                Attendance Cycle
              </h4>
              <div className="d-flex flex-column flex-md-row align-items-center border rounded p-2 p-md-3 bg-gray-50">
                <span className="px-3 px-md-4 py-1 py-md-2 border-end text-secondary">
                  1
                </span>
                <span className="flex-grow px-3 px-md-4 text-dark my-2 my-md-0 text-center text-md-start">
                  Attendance Cycle
                </span>
                <div className="d-flex align-items-center w-100 w-md-auto justify-content-center">
                  <input
                    type="text"
                    className="border px-2 py-1 py-md-2 w-50 w-md-24 rounded-md text-secondary me-2"
                    placeholder="Days"
                  />
                  <span className="px-2 px-md-4 text-dark">to</span>
                  <input
                    type="text"
                    className="border px-2 py-1 py-md-2 w-50 w-md-12 rounded-md text-secondary"
                    defaultValue="31"
                  />
                </div>
              </div>
            </div>

            {/* Work Week */}
            <div className="border p-3 p-md-4 rounded-md shadow-lg mb-4">
              <h4 className="font-bold mb-2 text-primary h5">Work Week</h4>
              <div className="d-flex flex-column flex-md-row align-items-center border rounded p-2 p-md-3 mb-2 bg-gray-50">
                <span className="px-3 px-md-4 py-1 py-md-2 border-end text-secondary">
                  2
                </span>
                <span className="flex-grow px-3 px-md-4 text-dark my-2 my-md-0 text-center text-md-start">
                  Work Week
                </span>
                <div className="d-flex align-items-center w-100 w-md-auto justify-content-center">
                  <input
                    type="text"
                    className="border px-2 py-1 py-md-2 w-50 w-md-12 rounded-md text-secondary me-2"
                    defaultValue="1"
                  />
                  <select className="border px-2 py-1 py-md-2 rounded-md bg-white text-secondary w-50 w-md-auto">
                    <option>Per month Weeks</option>
                  </select>
                </div>
              </div>

              {/* Work Week Table */}
              <Box sx={{ width: "100%", padding: { xs: 1, sm: 2 } }}>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "bold", color: "text.primary", fontSize: { xs: "1rem", sm: "1.25rem" } }}
                >
                  WORK WEEK 6
                </Typography>
                <Typography variant="body2" sx={{ color: "text.secondary", fontSize: { xs: "0.75rem", sm: "0.875rem" } }}>
                  This is a 6-day Work Week rule with Weekly off set as Sunday.
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: "bold",
                    marginTop: 1,
                    color: "text.primary",
                    fontSize: { xs: "0.75rem", sm: "0.875rem" }
                  }}
                >
                  Effective Date: 05 Feb, 2025
                </Typography>

                <Box sx={{ overflowX: "auto", marginTop: 2 }}>
                  <TableContainer
                    component={Paper}
                    sx={{
                      border: "1px solid #ccc",
                      boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
                      minWidth: { xs: "600px", sm: "auto" }
                    }}
                  >
                    <Table size="small">
                      <TableHead>
                        <TableRow sx={{ backgroundColor: "#E0E0E0" }}>
                          <TableCell
                            align="center"
                            sx={{
                              fontWeight: "bold",
                              border: "1px solid #ccc",
                              color: "text.primary",
                              fontSize: { xs: "0.75rem", sm: "0.875rem" }
                            }}
                          >
                            Week
                          </TableCell>
                          {days.map((day) => (
                            <TableCell
                              key={day}
                              align="center"
                              sx={{
                                fontWeight: "bold",
                                border: "1px solid #ccc",
                                color: "text.primary",
                                fontSize: { xs: "0.75rem", sm: "0.875rem" }
                              }}
                            >
                              {day}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {workWeekData.map((row) => (
                          <TableRow key={row.week}>
                            <TableCell
                              align="center"
                              sx={{
                                fontWeight: "bold",
                                border: "1px solid #ccc",
                                fontSize: { xs: "0.75rem", sm: "0.875rem" }
                              }}
                            >
                              {row.week}
                            </TableCell>
                            {row.days.map((color, i) => (
                              <TableCell
                                key={i}
                                align="center"
                                sx={{ 
                                  border: "1px solid #ccc",
                                  padding: { xs: "4px", sm: "8px" }
                                }}
                              >
                                {getColorBox(color)}
                              </TableCell>
                            ))}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                {/* Legend Section */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    gap: { xs: 1, sm: 2 },
                    marginTop: 2,
                    alignItems: { xs: "flex-start", sm: "center" }
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{ color: "text.secondary", fontSize: { xs: "0.75rem", sm: "0.875rem" } }}
                  >
                    {getColorBox("green")} Working Day
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ color: "text.secondary", fontSize: { xs: "0.75rem", sm: "0.875rem" } }}
                  >
                    {getColorBox("red")} Weekly Off
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ color: "text.secondary", fontSize: { xs: "0.75rem", sm: "0.875rem" } }}
                  >
                    {getColorBox("yellow")} Half Day
                  </Typography>
                </Box>
              </Box>
            </div>

            {/* Shift Section */}
            <Box sx={{ padding: { xs: 1, sm: 2 }, marginTop: 4 }}>
              <Typography
                variant="h5"
                sx={{ 
                  fontWeight: "bold", 
                  color: "text.primary",
                  fontSize: { xs: "1.25rem", sm: "1.5rem" }
                }}
              >
                Shift
              </Typography>
              <Box
                sx={{
                  overflowX: "auto",
                  marginTop: 2,
                  marginLeft: { xs: -1, sm: 0 },
                  marginRight: { xs: -1, sm: 0 }
                }}
              >
                <TableContainer
                  component={Paper}
                  sx={{
                    border: "1px solid #ccc",
                    minWidth: "600px",
                    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <Table size="small">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: "#D6E0F5" }}>
                        {[
                          "S.No",
                          "Shift Name",
                          "In Time",
                          "Out Time",
                          "Action",
                        ].map((header) => (
                          <TableCell
                            key={header}
                            align="center"
                            sx={{
                              fontWeight: "bold",
                              border: "1px solid #ccc",
                              color: "text.primary",
                              fontSize: { xs: "0.75rem", sm: "0.875rem" }
                            }}
                          >
                            {header}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {addresses.map((_, index) => (
                        <TableRow key={index}>
                          {[...Array(4)].map((_, i) => (
                            <TableCell
                              key={i}
                              align="center"
                              sx={{
                                border: "1px solid #ccc",
                                padding: { xs: "4px", sm: "8px" },
                                fontSize: { xs: "0.75rem", sm: "0.875rem" },
                                color: "text.primary",
                              }}
                            ></TableCell>
                          ))}

                          {/* Action Buttons */}
                          <TableCell
                            align="center"
                            sx={{
                              border: "1px solid #ccc",
                              padding: { xs: "4px", sm: "8px" },
                            }}
                          >
                            <div className="d-flex justify-content-center">
                              <IconButton
                                color="primary"
                                onClick={() => handleView(index)}
                                size="small"
                                sx={{ padding: { xs: "4px", sm: "8px" } }}
                              >
                                <Visibility fontSize="small" />
                              </IconButton>
                              <IconButton
                                color="warning"
                                onClick={() => handleEdit(index)}
                                size="small"
                                sx={{ padding: { xs: "4px", sm: "8px" } }}
                              >
                                <Edit fontSize="small" />
                              </IconButton>
                              <IconButton
                                color="error"
                                onClick={() => handleDelete(index)}
                                size="small"
                                sx={{ padding: { xs: "4px", sm: "8px" } }}
                              >
                                <Delete fontSize="small" />
                              </IconButton>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Box>

            {/* Holiday Section */}
            <Box sx={{ padding: { xs: 1, sm: 2 }, marginTop: 4 }}>
              <Typography
                variant="h5"
                sx={{ 
                  fontWeight: "bold", 
                  color: "text.primary",
                  fontSize: { xs: "1.25rem", sm: "1.5rem" }
                }}
              >
                Holiday
              </Typography>
              <Box
                sx={{
                  overflowX: "auto",
                  marginTop: 2,
                  marginLeft: { xs: -1, sm: 0 },
                  marginRight: { xs: -1, sm: 0 }
                }}
              >
                <TableContainer
                  component={Paper}
                  sx={{
                    border: "1px solid #ccc",
                    minWidth: "600px",
                    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <Table size="small">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: "#D6E0F5" }}>
                        {[
                          "S.No",
                          "Start Date",
                          "End Date",
                          "Festival Name",
                          "Action",
                        ].map((header) => (
                          <TableCell
                            key={header}
                            align="center"
                            sx={{
                              fontWeight: "bold",
                              border: "1px solid #ccc",
                              color: "text.primary",
                              fontSize: { xs: "0.75rem", sm: "0.875rem" }
                            }}
                          >
                            {header}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {holidayData.map((_, index) => (
                        <TableRow key={index}>
                          {[...Array(4)].map((_, i) => (
                            <TableCell
                              key={i}
                              align="center"
                              sx={{
                                border: "1px solid #ccc",
                                padding: { xs: "4px", sm: "8px" },
                                fontSize: { xs: "0.75rem", sm: "0.875rem" },
                                color: "text.primary",
                              }}
                            ></TableCell>
                          ))}
                          {/* Action Buttons */}
                          <TableCell
                            align="center"
                            sx={{
                              border: "1px solid #ccc",
                              padding: { xs: "4px", sm: "8px" },
                            }}
                          >
                            <div className="d-flex justify-content-center">
                              <IconButton
                                color="primary"
                                onClick={() => handleHolidayView(index)}
                                size="small"
                                sx={{ padding: { xs: "4px", sm: "8px" } }}
                              >
                                <Visibility fontSize="small" />
                              </IconButton>
                              <IconButton
                                color="warning"
                                onClick={() => handleHolidayEdit(index)}
                                size="small"
                                sx={{ padding: { xs: "4px", sm: "8px" } }}
                              >
                                <Edit fontSize="small" />
                              </IconButton>
                              <IconButton
                                color="error"
                                onClick={() => handleHolidayDelete(index)}
                                size="small"
                                sx={{ padding: { xs: "4px", sm: "8px" } }}
                              >
                                <Delete fontSize="small" />
                              </IconButton>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Box>

            {/* Next Button */}
            <Box sx={{ textAlign: "center", marginTop: 4, padding: { xs: 1, sm: 2 } }}>
              <Button variant="contained" color="primary" size="large">
                Next
              </Button>
            </Box>
          </Box>

          {/* View Dialog */}
          <Dialog 
            open={viewOpen} 
            onClose={handleCloseViewDialog}
            fullWidth
            maxWidth="sm"
          >
            <DialogTitle>View Details</DialogTitle>
            <DialogContent>
              <Typography variant="body1">
                Shift Name: {selectedRecord?.shiftName}
              </Typography>
              <Typography variant="body1">
                In Time: {selectedRecord?.inTime}
              </Typography>
              <Typography variant="body1">
                Out Time: {selectedRecord?.outTime}
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseViewDialog} color="primary">
                Close
              </Button>
            </DialogActions>
          </Dialog>

          {/* Edit Dialog */}
          <Dialog 
            open={editOpen} 
            onClose={handleCloseEditDialog}
            fullWidth
            maxWidth="sm"
          >
            <DialogTitle>Edit Shift</DialogTitle>
            <DialogContent>
              <TextField
                fullWidth
                label="Shift Name"
                value={selectedRecord?.shiftName || ""}
                onChange={(e) =>
                  setSelectedRecord({
                    ...selectedRecord,
                    shiftName: e.target.value,
                  })
                }
                margin="normal"
                size="small"
              />
              <TextField
                fullWidth
                label="In Time"
                value={selectedRecord?.inTime || ""}
                onChange={(e) =>
                  setSelectedRecord({
                    ...selectedRecord,
                    inTime: e.target.value,
                  })
                }
                margin="normal"
                size="small"
              />
              <TextField
                fullWidth
                label="Out Time"
                value={selectedRecord?.outTime || ""}
                onChange={(e) =>
                  setSelectedRecord({
                    ...selectedRecord,
                    outTime: e.target.value,
                  })
                }
                margin="normal"
                size="small"
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseEditDialog} color="primary">
                Cancel
              </Button>
              <Button onClick={handleSaveEdit} color="primary">
                Save
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    </div>
  );
}

export default Companyattendance;
